import styled from 'styled-components';

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0 1.5rem 1.5rem 1.5rem;

  & > .hefesto-title h1 {
    color: ${({ theme }) => theme.colors.grayDark3};
    margin-bottom: 0;
  }
  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;

export const HeaderButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;

  button:nth-child(2) {
    width: 48px;
    display: flex;
    justify-content: center;
  }
`;

export const HeaderSection = styled.div`
  margin-top: 1rem;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  .subtitle {
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark4};
    line-height: 1.5rem;
  }
`;

export const ContentToggle = styled.button`
  background: none;
  border: none;
  display: flex;
  color: ${({ theme }) => theme.colors.blue6};
  gap: 0.5rem;

  cursor: pointer;
`;

export const ResumeHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OrderUpdateContainer = styled.div`
  min-height: 76vh;
  background-color: ${({ theme }) => theme.colors.gray8};
  padding-bottom: 6rem;
`;

export const CheckboxSection = styled.div`
  background-color: ${({ theme }) => theme.colors.white};

  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark4};

  margin-top: 0.5rem;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const TextBold = styled.span`
  font-weight: 600;
`;

export const CheckboxContainer = styled.div`
  display: grid;

  grid-template-columns: 25.5% 25.5% 1fr;

  padding-left: 3.1px; //O checkbox tem uma expansão além dos limites do componente
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  gap: 0.5rem;

  align-items: center;
  .tooltipIconContainer {
    max-height: 16px;
    .hefesto-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const ItemUpdateSection = styled.div`
  background-color: ${({ theme }) => theme.colors.white};

  margin-top: 0.5rem;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ItemUpdateTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const ItemUpdateText = styled.span``;

export const ItemUpdateInputsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  gap: 1.5rem;

  .hefesto-textarea,
  textarea {
    max-height: 9rem;
    width: 100%;
  }
`;

export const ItemUpdateInputsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  column-gap: 1.5rem;

  /* .hefesto-datefield__input input::placeholder {
    color: white; //Input não tem placeholder nas propriedades
  } */

  .hefesto-input-wrapper,
  .hefesto-stepper {
    height: fit-content;
  }

  .hefesto-icon.Calendar {
    max-height: 1.5rem;
  }
`;
